<template>
  <div class="w-100 flex-box bg-secondary">
    <div class="card bg_disabled">
      <div class="card-header pb-4 border-0">
        <!-- <div class="logo-center text-center pb-4 border-bottom">
          <img class="icon-logo" src="@/assets/img/brand/favicon.svg" />
        </div> -->
        <div
          v-if="this.$route.query && this.$route.query.login && invitation"
          class="text-muted text-center mt-0 mb-3"
        >
          <small
            >You’ve received an invitation from
            {{ invitation.invitedBy.firstName }}
            {{ invitation.invitedBy.lastName }} user to collaborate on the
            {{ invitation.project.name }} Project, please login or join up below
            to get into it!</small
          >
        </div>
      </div>
      <div class="card-body bg-white">
        <div class="logo-head mx-auto">
          <!-- <a>
            <img src="@/assets/img/brand/TaskFormcx-black.svg" />
          </a> -->
          <logo/>
        </div>
        <div class="text-muted text-center mb-5" style="margin-top: 50px">
          <span class="h2 text-black lh-110 mb-2">Sign in</span>
        </div>
        <!-- <div class="btn-wrapper text-center btn-min mb-3">
          <a
            class="btn btn-neutral btn-block btn-icon my-2"
            @click="loginWithLinkedin"
          >
            <span class="btn-inner--icon">
              <img src="@/assets/img/icons/color/linkedin.svg" />
            </span>
            <span class="btn-inner--text">LinkedIn</span>
          </a>
          <a
            class="btn btn-neutral btn-block btn-icon my-2"
            @click="loginWithGoogle"
          >
            <span class="btn-inner--icon">
              <img src="@/assets/img/icons/common/google.svg" />
            </span>
            <span class="btn-inner--text">Google</span>
          </a>
          <a
            class="btn btn-neutral btn-block btn-icon my-2"
            @click="loginWithFacebook"
          >
            <span class="btn-inner--icon">
              <img src="@/assets/img/icons/color/facebook.svg" />
            </span>
            <span class="btn-inner--text">facebook</span>
          </a>
        </div> -->
        <!-- <div class="text-center text-muted mb-4">
          <small>Or sign in with credentials</small>
        </div> -->
        <form role="form">
          <base-input
            v-model="email"
            alternative
            class="mb-3"
            prepend-icon="ni ni-email-83"
            placeholder="Email"
          />
          <div v-if="$v.email.$error" class="error field">
            Valid email is required
          </div>

          <base-input
            v-model="password"
            alternative
            class="mb-3"
            prepend-icon="ni ni-lock-circle-open"
            type="password"
            placeholder="Password"
            @keypress.enter="handleLogin"
          />

          <div v-if="$v.password.$error" class="error field">
            Field is required
          </div>
          <!-- <div class="row">
                        <div class="col-auto">
                            <base-checkbox v-model="rememberMe">Remember me</base-checkbox>
                        </div>
                        <div class="col text-right" @click="$emit('iAmNewClicked')">
                            <base-checkbox v-model="createAccount" type="checkbox" value="agree"  class="pl-0">I’m new to TaskFrom</base-checkbox>
                        </div>
          </div>-->

          <div class="text-center">
            <base-button
              type="primary"
              class="my-4 btn-block"
              @click="handleLogin"
              >Sign in</base-button
            >
          </div>
        </form>
        <p class="text-center text-muted mb-5" style="margin-top: -15px">
          <a
            style="cursor: pointer"
            class
            @click="$emit('forgotPasswordLinkClicked')"
          >
            <small>Forgot password?</small>
          </a>
        </p>
        <button
          style="cursor: pointer"
          class="btn btn-outline-success btn-block"
          @click="$emit('iAmNewClicked')"
        >
          Create account
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { required, minLength, between, email } from "vuelidate/lib/validators";
import Logo from './Logo.vue';
export default {
  components: { Logo },
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      rememberMe: false,
      createAccount: false,
      invitation: null,
    };
  },
  validations: {
    email: {
      email,
      required,
      minLength: minLength(4),
    },
    password: {
      required,
    },
  },
  mounted() {
    if (this.$route.query && this.$route.query.login && this.$route.query.token) {
      this.fetchInvitation(this.$route.query.token)
        .then((r) => {
          this.invitation = r.data;
          this.email = this.invitation.invitedTo.email;
        })
        .catch((err) => {});
    }
  },

  methods: {
    ...mapMutations(["setLoading"]),
    ...mapMutations("user", ["setRegistrationData"]),
    ...mapActions("user", ["performLoginPassword", "fetchUserInfoAction"]),
    ...mapActions("common", ["fetchInvitation"]),
    getAccessTokenFromSocial(provider) {
      const clientId = process.env.VUE_APP_CLIENT_ID;
      const clientSecret = process.env.VUE_APP_CLIENT_SECRET;
      this.setLoading(true);
      this.$auth
        .authenticate(provider)
        .then((r) => {
          this.$auth
            .login({
              access_token: r.data.access_token,
              client_id: clientId,
              client_secret: clientSecret,
              grant_type: "social",
              provider: provider,
            })
            .then((r) => {
              return this.fetchUserInfoAction();
            })
            .then((r) => {
              if (this.$route.query.login) {
                this.$router.go(-1);
              } else {
                this.$router.go();
              }
              this.setLoading(false);
            })
            .catch((e) => {
              console.log(e);
              this.$snack.success("Invalid Credentials.");
              this.setLoading(false);
            });
        })
        .catch((e) => {
          this.$snack.success("Invalid Credentials.");
          this.setLoading(false);
        });
    },
    handleLogin() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      // this.performLoginPassword({username:this.email, password:this.password}).then(r => {
      //    this.$router.push('/projects')
      // }).catch(err => {
      //     this.$snack.success('Invalid Credentials.')
      // })

      const clientId = process.env.VUE_APP_CLIENT_ID;
      const clientSecret = process.env.VUE_APP_CLIENT_SECRET;
      this.setLoading(true);
      //initially demo used to be login, once user enters wrong pwd
      //there will be not authenitcated user.
      //hence trying loggoing out was creating problem
      if (this.$auth.isAuthenticated()) {
        this.$auth.logout({}).then((r) => {
           this.attempLogin();
        });
      } else {
         this.attempLogin();
      }
    },
    loginWithLinkedin() {
      const provider = "linkedin";
      this.getAccessTokenFromSocial("linkedin");
    },

    loginWithFacebook() {
      this.getAccessTokenFromSocial("facebook");
    },
    loginWithGoogle() {
      this.getAccessTokenFromSocial("google");
    },

    loginWithLive() {
      this.getAccessTokenFromSocial("live");
    },

   async attempLogin() {
      const clientId = process.env.VUE_APP_CLIENT_ID;
      const clientSecret = process.env.VUE_APP_CLIENT_SECRET;
      try {
        let res = await this.$auth.login({
          username: this.email,
          password: this.password,
          client_id: clientId,
          client_secret: clientSecret,
          grant_type: "password",
        })
        

        // if (this.$route.query.login) {
        //         this.$router.go(-1);
        //       } else {
        //         this.$router.go();
        //       }

        if(this.invitation) {
          this.$router.replace({ name: "tasks.home", params: {id:this.invitation.project.id}, query: {preview: true, type:this.invitation.invitation_type} })
        }
        else if(this.$route.query.login) {
          this.$router.push(this.$route.query.redirect || '/')
        } else {
          this.$router.go();
        }

          this.setLoading(false);
      } catch(e) {
        // console.log(e.response.data, "error response")
          if(e.response.data && e.response.data.hint == "inactive_account") {
            this.setRegistrationData({email: this.email})
            this.$emit('verificationNeeded')
          } else {
            this.$snack.success("Invalid Credentials.");
          }
          
          this.setLoading(false);
      }
      
    },
  },
};
</script>

<style>
a.btn {
  cursor: pointer;
}
</style>

<style lang="scss">
.btn-1 {
  padding: 7px;
}
.logo-head {
  text-align: center;
  img {
    max-width: 120px;
    width: 100%;
  }
}
@media only screen and (min-width: 993px) {
  .logo-head {
    img {
      max-width: 170px;
    }
  }
}
</style>
